'use client';

import type { PaymentConfig, ReceiptSettings } from '@/lib/templates/schema';
import { SectionDivider } from './SectionDivider';

interface PaymentSectionProps {
  config: PaymentConfig;
  settings: ReceiptSettings;
}

export function PaymentSection({ config, settings }: PaymentSectionProps) {
  // Get the appropriate fields based on payment type
  const fields = config.paymentType === 'card' ? config.cardFields : config.cashFields;
  const isNarrow = settings.spacing === 'narrow';

  return (
    <div className={`receipt-section ${isNarrow ? 'py-0.5' : 'py-2'}`}>
      <div className={isNarrow ? '' : 'space-y-0.5'} style={{ lineHeight: isNarrow ? 1.15 : 1.4 }}>
        {fields?.map((field) => (
          <div
            key={field.id}
            className="flex justify-between gap-2"
            style={{
              fontSize: settings.fontSize,
              fontFamily: settings.font,
            }}
          >
            <span className="shrink-0 whitespace-pre">{field.label}</span>
            <span className="text-right break-all whitespace-pre">{field.value}</span>
          </div>
        ))}
      </div>

      {/* Divider */}
      {config.showDivider && (
        <SectionDivider style={config.dividerStyle} settings={settings} />
      )}
    </div>
  );
}

